import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {Type} from "../../../infrastructure/type";
import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {APP} from "../../app/consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class MyScoresClickEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;
  screen: APP.ANALYTICS.SOURCES;
  screenId: Type<EntityViewModel>;

  // not implemented yet
  clickType: ANALYTICS.CLICK_TYPES;

  constructor(source: APP.ANALYTICS.SOURCES, screen: APP.ANALYTICS.SOURCES = null, screenId: Number, clickType: ANALYTICS.CLICK_TYPES) {
    super('', 'click', 'my-scores');

    this.screenId = screenId;
    this.source = source;
    this.screen = screen;
    this.clickType = clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.screenId = this.screenId;
    properties.source = this.source;
    properties.screen = this.screen;
    properties.clickType = this.clickType;

    return properties;
  }

}
